import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Text } from '@node-space/ui-components'
import { LogoColor } from 'types/types'
import { Logo } from './Logo'

export const PoweredByBvnk = () => {
  const { t } = useTranslation()

  return (
    <Box
      flex
      width="full"
      align="center"
      justify="end"
      gap={8}
      className="text-generic-foreground-faint"
    >
      <Text variant="caption-text" color="faint">
        {t('poweredBy')}
      </Text>
      <Logo logoColor={LogoColor.INHERIT} isSmall />
    </Box>
  )
}
